/*
setLogin
setUType
setName
setToken
*/
export const setLogin=(value)=>({type: "setLogin", value});
export const setUType=(value)=>({type: "setUType", value});
export const setName=(value)=>({type: "setName", value});
export const setToken=(value)=>({type: "setToken", value});
export const setFacilityId=(value)=>({type: "setFacilityId", value});
export const setFacilityName=(value)=>({type: "setFacilityName", value});